var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuriname(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_6977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2536 7.82611H0.746344C0.264047 9.12614 0 10.5322 0 12C0 13.4678 0.264047 14.874 0.746344 16.1739H23.2536C23.736 14.874 24 13.4678 24 12C24 10.5322 23.736 9.12614 23.2536 7.82611Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0347 24C16.1448 24 19.7718 21.9332 21.9345 18.7826H2.13496C4.29768 21.9332 7.92459 24 12.0347 24Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0347 9.15527e-05C16.1448 9.15527e-05 19.7718 2.0669 21.9345 5.21747H2.13496C4.29768 2.0669 7.92459 9.15527e-05 12.0347 9.15527e-05Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7.82611L13.036 11.0145H16.3887L13.6763 12.9854L14.7124 16.1739L12 14.2033L9.28758 16.1739L10.3237 12.9854L7.61128 11.0145H10.964L12 7.82611Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_6977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuriname);
export default __webpack_public_path__ + "static/media/suriname.17bce07dc7b60dddd6d099ec66dd18d0.svg";
export { ForwardRef as ReactComponent };